import environment from "./endpoints";

const PROD_API_URL = "https://api.finance.profitsocial.com";

export default environment(PROD_API_URL);
